/** Loose golden chaff with a low asymmetric silhouette and individually scattered husks. */
import { checkEnvelope, checkScope, el, n, partGroup } from '../../svg';
import type { PieceArt, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, grainRng, ground, line } from './machinerySvg';
export interface ChaffPileParams { readonly scatter: number }
export type ChaffPileRecipe = PieceRecipe<'mill.chaff_pile.v1', ChaffPileParams>;
export const CHAFF_PILE_FRAME = { w: 100, h: 40 } as const;
export const MILL_CHAFF_PILE: ChaffPileRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.chaff_pile.default.v1', generatorId: 'mill.chaff_pile.v1',
  seed: 20071012, paletteId: 'millrace_amber', params: { scatter: 0.7 },
};
export function buildChaffPile(recipe: ChaffPileRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_CHAFF_PILE.generatorId); checkScope(scope);
  const scatter = amount(recipe.params.scatter, 'scatter'), random = grainRng(recipe), parts: string[] = [];
  let heap = el('path', { d: 'M12 35Q23 30 32 19Q43 7 52 13Q63 14 72 24Q84 27 91 35Q50 39 12 35Z', fill: p.paperBase, stroke: p.woodShadow, 'stroke-width': 0.8 })
    + el('path', { d: 'M23 29Q37 11 48 13Q59 14 66 23Q47 18 34 29Z', fill: p.woodLight });
  for (let i = 0; i < 90; i++) {
    const angle = random(`angle.${i}`) * Math.PI * 2, radius = Math.sqrt(random(`radius.${i}`));
    const x = 51 + Math.cos(angle) * radius * 32, y = 27 + Math.sin(angle) * radius * 9;
    const length = 1.5 + random(`length.${i}`) * 3;
    heap += line(x, y, x + length, y - 1.4, i % 3 ? p.paperLight : p.paperShadow, 0.65);
  }
  let loose = '';
  for (let i = 0; i < Math.round(scatter * 25); i++) {
    const x = 5 + random(`loose.x.${i}`) * 89, y = 34 + random(`loose.y.${i}`) * 3;
    loose += el('path', { d: `M${n(x - 1.5)} ${n(y)}Q${n(x)} ${n(y - 2)} ${n(x + 2)} ${n(y - 0.5)}L${n(x)} ${n(y + 0.5)}Z`, fill: p.paperLight });
  }
  const body = partGroup(parts, 'chaff-ground', ground(100, 40, p)) + partGroup(parts, 'golden-chaff-heap', heap)
    + partGroup(parts, 'scattered-husks', loose || el('g', { 'data-empty': 'true' }));
  return { frame: CHAFF_PILE_FRAME, body, anchors: { support: { x: 50, y: 40 } }, parts, openings: [] };
}
